import Image from "next/image";

const BewareOfScammers = ({ data }: { data: any[] }) => {
  if (data?.length == 0) return null;
  return (
    <a
      href={data[0]?.redirection_url}
      target={data[0]?.open_new_tab ? "_blank" : ""}
    >
      <Image
        src={data[0]?.banner_image}
        alt={data[0]?.alt_text}
        width={data[0]?.banner_slot?.width || 300}
        height={data[0]?.banner_slot?.height || 200}
        className="rounded-lg"
        priority={false}
      />
    </a>
  );
};
export default BewareOfScammers;
